/* --------------------------------------------------------------------------
	Scrolling
-------------------------------------------------------------------------- */

/* globals jQuery, Site */

(function ($, Site) {
	function init() {
		if (!$('.js-component-scroll').length) {
			return;
		}

		Raf = window.requestAnimationFrame;
		LastScrollTop = window.pageYOffset;
		WindowHeight = $(window).height();

		scrollLoop();
		onScroll();
	}

	function scrollLoop() {
		var scrollTop = window.pageYOffset;

		if (LastScrollTop === scrollTop) {
			Raf(scrollLoop);

			return;
		} else {
			LastScrollTop = scrollTop;

			onScroll();
			Raf(scrollLoop);
		}
	}

	function onScroll() {
		if ($(window).width() >= Site.MinLG) {
			$('.js-component-scroll-item-inner').each(function () {
				var $parent = $(this).closest('.js-component-scroll-item');
				var scrollSpeed = parseInt($parent.data('rate')) * -0.05;
				var offset = $(window).height() - $parent[0].getBoundingClientRect().top;

				$(this).css('transform', 'translate3d(0, ' + offset * scrollSpeed + 'px, 0)');
			});
		} else {
			$('.js-component-scroll-item-inner').css('transform', '');
		}
	}

	Site.OnInit.push(init);
})(jQuery, Site);
